import React, { FC, MouseEventHandler } from "react";
import AlertDialog from "../../app/alert-dialog";
import { Button, Checkbox, FormControl, FormControlLabel, Stack, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { bulkRecordingPopupStateAtom, setWillShowPopup } from "../../../stores/jotai/bulkRecordingPopupState";
import { noop } from "lodash";

interface BulkRecordingUploadDialogProps {
    open: boolean;
    onProceed?: Function | MouseEventHandler;
    onDiscard?: Function | MouseEventHandler;
}

const BulkRecordingUploadDialog: FC<BulkRecordingUploadDialogProps> = (props) => {
    const { open, onDiscard, onProceed } = props;
    const [bulkRecordingPopupState, setBulkRecordingPopupState] = useAtom(
        bulkRecordingPopupStateAtom
    );
    const { willShow: showUploadDialog } = bulkRecordingPopupState;

    return (
        <AlertDialog
            open={open}
            title="Rename the audio files?"
            description={
                <Stack spacing={2}>
                    <Typography fontWeight={400}>
                        To make things easier, we'll use the name of the file you upload
                        as the interviewee's name. So, please make sure to rename your
                        files with the interviewee's name before uploading them. Thanks
                    </Typography>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    inputProps={{ "aria-label": "controlled" }}
                                    checked={!showUploadDialog}
                                    onChange={(event) =>
                                        setWillShowPopup(
                                            setBulkRecordingPopupState,
                                            !event?.target?.checked
                                        )
                                    }
                                />
                            }
                            label="Don't show this again"
                        />
                    </FormControl>
                </Stack>
            }
            confirmButton={
                <Button
                    color="primary"
                    variant="contained"
                    onClick={(event) => onProceed(event)}
                >
                    Understood
                </Button>
            }
            abortButton={
                <Button onClick={(event) => onDiscard(event)}>Cancel</Button>
            }
        />
    );
};

BulkRecordingUploadDialog.defaultProps = {
    onProceed: noop,
    onDiscard: noop,
};

export default BulkRecordingUploadDialog;
